import React from 'react'
import PropTypes from 'prop-types';

import { FormWrapper, Input, Checkbox } from 'components';
import { TransitionablePortal, Modal, Header, Form } from 'semantic-ui-react';

import { API } from 'services';

import { Typeof } from 'utils';

import './style.css';

class ModalUploadFirmware extends React.Component {

  constructor(props) {
    super(props);

    this.fileInput = React.createRef();

    this.handleSubmit = this.handleSubmit.bind(this);

    this.isEdit = Typeof.object(props.firmware);

    let state = {
      actions: {
        submit: {
          name: "Valider",
          callback: this.handleSubmit
        },
        cancel: {
          name: "Annuler",
          callback: props.onClose
        }
      },

      icon: 'add',
      title: 'Nouveau firmware',
      firmware: {},
      method: API.post,
      route: `/firmwares`
    };

    if (this.isEdit) {

      state = {
        ...state,
        icon: 'edit',
        title: 'Modification firmware',
        firmware: props.firmware,
        method: API.put,
        route: `/firmwares/${props.firmware.channel}/${props.firmware.version}`
      };
    }

    this.state = state;
  }

  handleSubmit(data, onSucess, onError) {

    let payload = null;

    //Remove 'file' property
    delete data.file;

    if(!this.isEdit) {

      payload = new FormData();
      payload.append('file', this.fileInput.current.files[0]);
      payload.append('data', JSON.stringify(data));

    } else {

      payload = data;
    }

    this.state.method(this.state.route, payload)
      .then((response) => {
        this.props.onClose(response.data);
      })
      .catch((error) => {
        onError(API.violations(error));
      });
  }

  render() {
    return (
      <TransitionablePortal open transition={{ animation: "fade down", duration: 250 }}>
        <Modal open size='small'>
          <Header icon="upload" content="Nouveau firmware" />
          <Modal.Content>

            <FormWrapper actions={this.state.actions}>

              {/* File */}
              {!this.isEdit &&
                <Form.Field>
                  <label htmlFor="inputFile" className="required">Binaire</label>
                  <input type="file" id="inputFile" name="file" ref={this.fileInput} accept=".bin" />
                </Form.Field>
              }

              {/* Minimum app version */}
              <Form.Field>
                <label htmlFor="inputMinimumAppVersion" className="required">Version minimale de l'application</label>
                <Input id="inputMinimumAppVersion" name="minimum_app_version" placeholder="Ex: 1.0.0" value={this.state.firmware.minimum_app_version} />
                <span className="quote">Indique la version minimale de l'application requise pour appliquer cette version du micrologiciel</span>
              </Form.Field>

              {/* Available */}
              <Form.Field>
                <Checkbox label="Disponible" name="available" checked={this.state.firmware.available} />
              </Form.Field>

            </FormWrapper>

          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

ModalUploadFirmware.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default ModalUploadFirmware;
